import { render, staticRenderFns } from "./takeEmail.vue?vue&type=template&id=62721de6"
import script from "./takeEmail.vue?vue&type=script&lang=js"
export * from "./takeEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports